import { useFormContext } from 'react-hook-form'
import PhoneInputWithCountry from 'react-phone-number-input/react-hook-form'
import { FormValues } from '..'
import { Rules } from '../validation'
import { DEFAULT_MOBILE_META, findMobileMeta } from '../utils'
import {
  AlertError,
  colors,
  fontSizes,
  Label,
  lineHeight,
  radii,
  speeds,
  Text,
} from '@ohgoodlord/design-system'
import { css } from '@emotion/react'

const ERROR_ID = 'mobile-error'

export const PhoneNumberFormField = ({ rules }: { rules: Rules<'mobile'> }) => {
  const {
    setValue,
    formState: { errors },
  } = useFormContext<FormValues>()

  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        gap: 5px;
        ${phoneNumberInputStyles(!!errors.mobile)}
      `}
    >
      <Label htmlFor="mobile">Contact number</Label>
      <PhoneInputWithCountry
        placeholder="Enter phone number"
        rules={rules}
        defaultCountry="GB"
        name="mobile"
        id="mobile"
        initialValueFormat="national"
        aria-invalid={!!errors.mobile}
        aria-describedby={errors.mobile ? ERROR_ID : undefined}
        onCountryChange={val => {
          if (val) {
            const mobileMeta = findMobileMeta(val) || DEFAULT_MOBILE_META
            setValue('mobileMeta', mobileMeta)
          }
        }}
      />
      {errors.mobile && (
        <div id={ERROR_ID}>
          <AlertError>
            <Text>{errors.mobile.message}</Text>
          </AlertError>
        </div>
      )}
    </div>
  )
}

const phoneNumberInputStyles = (isInvalid: boolean) => css`
  .PhoneInput {
    display: flex;
    align-items: center;
    border: solid 1px;
    border-color: ${isInvalid ? colors.red : colors.inputBorder};
    &:focus-within {
      border-color: ${colors.primary};
    }
    border-radius: ${radii.m};
    padding: 11px;
  }

  .PhoneInputInput {
    font-size: ${fontSizes.m};
    line-height: ${lineHeight};
    flex: 1 1 auto;
    width: 100%;
    margin: 0;
    border: none;
    outline: none;
    background: rgba(255, 255, 255, 0);
    min-width: 70px;
    color: ${colors.textPrimary};
    cursor: text;
    &:focus {
      outline: none;
    }
    &::placeholder {
      color: ${colors.inputPlaceholder};
    }
    transition: all ${speeds.fast} ease-in-out;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    width: 100%;
    position: relative;
    background-color: initial;
    &:hover {
      border-color: ${colors.inputBorderHover};
    }
    &:focus-within {
      border-color: ${colors.primary};
    }
  }

  .PhoneInputCountryIcon {
    width: 1.5em;
    height: 1em;
  }

  .PhoneInputCountryIconImg {
    display: block;
    width: 100%;
    height: 100%;
  }

  .PhoneInputInternationalIconPhone {
    opacity: 0.8;
  }

  .PhoneInputInternationalIconGlobe {
    opacity: 0.65;
  }

  .PhoneInputCountry {
    position: relative;
    align-self: stretch;
    display: flex;
    align-items: center;
    margin-right: 0.35em;
  }

  .PhoneInputCountrySelect {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: 1;
    border: 0;
    opacity: 0;
    cursor: pointer;
  }

  .PhoneInputCountrySelectArrow {
    display: block;
    content: '';
    width: 0.3em;
    height: 0.3em;
    margin-left: 0.35em;
    border-style: solid;
    border-color: currentColor;
    border-top-width: 0;
    border-bottom-width: 1px;
    border-left-width: 0;
    border-right-width: 1px;
    transform: rotate(45deg);
    opacity: 0.45;
  }
`
